import { Link } from 'react-router';
import { Icon } from './Icon.jsx';
import styles from './BackLink.module.css';

export function BackLink({ to, children, className = '' }) {
  return (
    <Link to={to} className={`${styles.backLink} ${className}`.trim()} data-enter="left">
      <Icon name="arrowLeft" />
      {children}
    </Link>
  );
}
